import { render } from "./ProductPriceChanges.vue?vue&type=template&id=00d3968e"
import script from "./ProductPriceChanges.vue?vue&type=script&lang=js"
export * from "./ProductPriceChanges.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__